import { render, staticRenderFns } from "./TSysLanguageModal.vue?vue&type=template&id=90d762e4&"
import script from "./TSysLanguageModal.vue?vue&type=script&lang=js&"
export * from "./TSysLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90d762e4')) {
      api.createRecord('90d762e4', component.options)
    } else {
      api.reload('90d762e4', component.options)
    }
    module.hot.accept("./TSysLanguageModal.vue?vue&type=template&id=90d762e4&", function () {
      api.rerender('90d762e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/TSysLanguageModal.vue"
export default component.exports